module.exports = __webpack_public_path__ + "media/images/kansai_recommended_symbol-2f6f23eccdf60c4718b41889b705cec9.jpeg";